/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：114
 */

"use strict"

var r
var o
var i
export { r as b }
export { o as a }
export { i as c };
(function (e) {
  e.RECTANGLE_FILL = "RECTANGLE_FILL"
  e.RECTANGLE_OUTLINE = "RECTANGLE_OUTLINE"
  e.CIRCLE_FILL = "CIRCLE_FILL"
  e.CIRCLE_OUTLINE = "CIRCLE_OUTLINE"
})(r || (r = {}));
(function (e) {
  e.TEMPLATE = "TEMPLATE"
  e.IMAGE = "IMAGE"
})(o || (o = {}));
(function (e) {
  e.CONTAIN = "contain"
  e.STRETCH = "stretch"
})(i || (i = {}))
export default o
